












































































import {
  defineComponent, computed,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useRouter } from '@ideavivat/vivat-2';

import i18n from '@/i18n';
import usePermission from '@/usePermission';

import gql from 'graphql-tag';

const AppSACICT = defineComponent({
  setup() {
    const { result, onResult } = useQuery(gql`
      query getMyInfo {
        me {
          id
          firstName
          lastName
          roles {
            id
            name
          }
        }
      }
    `, {}, {
      fetchPolicy: 'network-only',
    });

    const myInfo = useResult(result, null, (data) => data.me);

    const name = computed(() => {
      if (myInfo.value) {
        return `${myInfo.value.firstName} ${myInfo.value.lastName}`;
      }
      return '';
    });
    const role = computed(() => {
      return 'admin'; // HACK: DON'T COMMIT
      if (myInfo.value) {
        if (myInfo.value.roles.length > 0) return myInfo.value.roles[0].name;
      }
      return '';
    });

    const { router } = useRouter();

    const { hasPermission, loadPermission } = usePermission();

    const getProfileImage = computed(() => {
      if (myInfo.value) {
        if (myInfo.value.roles.length > 0) {
          if (myInfo.value.roles[0].name === 'admin') return '/sacict/Admin.png';
          if (myInfo.value.roles[0].name === 'mod') return '/sacict/Mod.png';
          if (myInfo.value.roles[0].name === 'recorder') return '/sacict/Recorder.png';
          if (myInfo.value.roles[0].name === 'visitor') return '/sacict/Visitor.png';
        }
      }
      return '/sacict/Visitor.png';
    });

    onResult((queryResult) => {
      // TODO: when finished
      // if (!queryResult?.data?.me) router.replace({ name: 'Logout' });
      // const permissions: any[] = [];
      // (queryResult?.data.me.roles as any[]).forEach((roleSub) => {
      //   roleSub.permissions.forEach((perm: any) => { permissions.push(perm.id); });
      // });
      // const uniquePermissions = [...new Set(permissions)];
      // localStorage.setItem('VIVAT_PERMISSION', JSON.stringify(uniquePermissions));
      // loadPermission();
    });

    return {
      getProfileImage,
      me: myInfo,
      name,
      role,
      hasPermission,
      i18n,
      navToI18N() {
        window.open(i18n.outLink.href);
      },
      navToForm() {
        window.open(decodeURIComponent('https%3A%2F%2Fdocs.google.com%2Fspreadsheets%2Fd%2F1EyvdUTgMhqi7gd52QkwCr9sU66O_Ag6KlfsgvgB8CP0%2Fedit%3Fusp%3Dsharing'));
      },
    };

    // return {
    //   myInfo,
    // };
  },
});

export default AppSACICT;
